<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.16667 15.8332H5.33333L12.5208 8.64567L11.3542 7.479L4.16667 14.6665V15.8332ZM16.0833 7.43734L12.5417 3.93734L13.7083 2.77067C14.0278 2.45123 14.4203 2.2915 14.8858 2.2915C15.3508 2.2915 15.7431 2.45123 16.0625 2.77067L17.2292 3.93734C17.5486 4.25678 17.7153 4.64234 17.7292 5.094C17.7431 5.54511 17.5903 5.93039 17.2708 6.24984L16.0833 7.43734ZM14.875 8.6665L6.04167 17.4998H2.5V13.9582L11.3333 5.12484L14.875 8.6665ZM11.9375 8.06234L11.3542 7.479L12.5208 8.64567L11.9375 8.06234Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "IconPen",
  props: {
    color: {
      type: String,
      default: "#F18E35",
    },
  },
};
</script>

<style scoped></style>
